import { render, staticRenderFns } from "./RequestModal.vue?vue&type=template&id=0c09bf2d&scoped=true"
import script from "./RequestModal.vue?vue&type=script&lang=js"
export * from "./RequestModal.vue?vue&type=script&lang=js"
import style0 from "./RequestModal.vue?vue&type=style&index=0&id=0c09bf2d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c09bf2d",
  null
  
)

export default component.exports